import fetch from 'isomorphic-fetch';
import config from './config';

const requestOptions = method => ({
  method,
  headers: { ...config.headers },
});

export function getFinancingPlans (price, deposit) {
  const URL = `${config.authEndPoint}/finance_plans?price=${price}&deposit=${deposit}`;
  const opt = {
    ...requestOptions('GET'),
  };

  return fetch(URL, opt)
    .then(r => r.json())
    .then(payload => (payload.error ? Promise.reject(payload) : Promise.resolve(payload)));
}

//http://localhost:8080/order-create?carId=495419944350378342&term=48&deposit=15000&ballonAmount=1
